export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Переглянути всіх',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Переглянути новачків!',
  'topicsToDiscuss': 'Обговорення тем',
  'OneOnOneMeet': 'Зустрічі 1:1',
  'learnMoreNetworking': 'Дізнатися більше про Networking Hub',
  'scanQrCode': 'Сканувати QR-код',
  'scannedBadge': 'Scanned badge',
  'viewProfile': 'Переглянути профіль',
  'message': 'Повідомлення',
  'userRatingDetails': 'Деталі рейтингу користувача',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Загальна кількість балів:',
  'scoreComposedOf': 'Кількість балів утворюється з наступних активностей:',
  'confirmationText': 'Ви впевнені? Цю дію не можна скасувати.',
  'discussionTopic': 'Зацікавленість в обговоренні',
  'notes': 'Нотатки',

  'welcomeMessage': "Ласкаво просимо до <strong>Networking Hub</strong> - місце, де з'являються нові зв'язки! Ось як це працює:",
  'connectingMadeSimpleTitle': 'Основна активність',
  'connectingMadeSimpleDescription':
    'Networking Hub пропонує різні активності та рівні, щоб допомогти вам ефективно встановлювати нові знайомства:',

  'newcomersDescription':
    '<strong>New Networkers:</strong> Переглядайте профілі новачків, додавайте цікаві до списку та надсилайте повідомлення.',
  'shortlistDescription': '<strong>Shortlist:</strong> Коли ви виявляєте інтерес до когось, він додається до вашого списку.',
  'contactedConnectedDescription':
    "<strong>Contacted/Connected:</strong> Коли ви зв'язуєтеся з кимось і отримуєте відповідь, він переходить до цих категорій.",
  'skipDescription': '<strong>Skip:</strong> Не зацікавлені? Просто пропустіть профіль і рухайтеся далі!',

  'enhancedNetworkingActivitiesTitle': 'Покращені нетворкінг активності',
  'enhancedNetworkingActivitiesDescription': 'Окрім прямих знайомств, Hub включає в себе:',

  'topicsToDiscussDescription':
    '<strong>Теми для обговорення:</strong> Знаходьте теми, які вас цікавлять, та знайомтеся з авторами або учасниками. Беріть участь в онлайн-дискусіях або заплануйте групові зустрічі для більш глибокого вивчення цих тем.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>Зустрічі 1:1:</strong> Керуйте запитами на зустрічі, відстежуйте заплановані зустрічі та організовуйте свій розклад без труднощів.',

  'gamificationTitle': 'Гейміфікація для розваг та залучення',
  'gamificationDescription':
    'Підвищуйте свою активність за допомогою таблиці лідерів, яка показує ваші бали та найактивніших учасників. Ось як ви можете заробляти бали:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1 000 балів:</strong> Заповнили свій профіль (включаючи фото).',
    points1000PushNotifications: '<strong>1 000 балів:</strong> Увімкнули push-сповіщення.',
    points100SendMeetingRequest: '<strong>100 балів:</strong> Надіслали запит на зустріч 1:1.',
    points400GetAcceptedRequest: '<strong>400 балів:</strong> Отримали підтвердження вашого запиту на зустріч 1:1.',
    points400AcceptRequest: '<strong>400 балів:</strong> Прийняли запит на зустріч 1:1.',
    points100DeclineRequest: '<strong>100 балів:</strong> Відхилили запит на зустріч 1:1.',
    points400CreateDiscussion: '<strong>400 балів:</strong> Створили тему для обговорення.',
    points50LikeDiscussion: '<strong>50 балів:</strong> Лайкнули тему обговорення.',
    points200PostFirstComment: '<strong>200 балів:</strong> Залишили перший коментар на іншій темі.',
    points100LikeOnTopic: '<strong>100 балів:</strong> Отримали лайк на вашу тему.',
    points200UniqueCommenter: '<strong>200 балів:</strong> Отримали унікального коментатора в своїй темі.',
    points100LikeShortlistUser: '<strong>100 балів:</strong> Лайкнули/додали користувача до списку.',
    points50SkipUser: '<strong>50 балів:</strong> Пропустили/скіпнули користувача.',
    points200StartChat: '<strong>200 балів:</strong> Почали чат.',
    points300GetChatResponse: '<strong>300 балів:</strong> Отримали відповідь в чатах.',
    points400RespondToChat: '<strong>400 балів:</strong> Відповіли на запит в чатах.',
    points500SpeedNetworking: '<strong>500 балів:</strong> За кожну сесію швидкого нетворкінгу.'
  },

  'finalMessage': 'Максимально використовуйте Networking Hub, відкривайте нові можливості та піднімайтеся в рейтингу!',

  'manageMeeting': 'Керувати зустріччю',
  'addToCalendar': 'Додати до календаря',
  'cancel': 'Скасувати',
  'accept': 'Прийняти',
  'accept&addToCalendar': 'Прийняти і додати до календаря',
  'editDetails': 'Редагувати деталі',
  'reject': 'Відхилити',
  'delete': 'Видалити',
  'exportContact': 'Експортувати контакт',
  'scheduleNewOneOnOne': 'Запланувати нову зустріч 1:1',
  'initiatedBy': 'Ініційовано',
  'rejectedBy': 'Відхилено',
  'you': 'вами',
  'meetPassed': 'Зустріч завершилася',
  'meetInProgress': 'Триває',

  'myOneOnOne': 'Мої 1:1',

  'speed': {
    history: 'Історія',
    minutes: 'хв.',
    users_available: 'доступні',
    rules: 'Правила',
    activate: 'Активувати',
    matching: 'Пошук...',
    start: 'Почати',
    find_a_user: 'Знайди користувача з таким же зображенням',
    find_a_user_number: 'Знайди користувача з таким же номером',
    waiting: 'Очікування...',
    speaking_now: 'Зараз говорить',
    networking_topics: 'Теми для спілкування',
    session_ended: 'Сесію завершено',
    find_next_partner: 'Знайти наступного партнера',
    find_next_group: 'Знайти наступну групу',
    partner_wasnt_ready: 'Партнер не був готовий',
    partner_wasnt_ready_description: 'Здається, партнер не був готовий до розмови. Давайте знайдемо нового!',
    start_matching: 'Почати пошук'
  },

  'findAndJoin': 'Час на пошук групи',
  'confirmStartTitle': 'Ви впевнені?',
  'confirmStartText': 'Ти вже знайшов свою групу?',
  'confirmStartCancelButtonTitle': 'Ні',
  'confirmStartConfirmButtonTitle': 'Так',

  'descriptionText': 'Тобі потрібно спочатку знайти свою групу та потім тільки натиснути кнопку "Почати"'
}
